import {
    ArrowLeftOutlined,
    MailOutlined,
    PhoneOutlined,
    UserOutlined,
    InboxOutlined,
} from "@ant-design/icons";
import { Card, Table, Tag } from "antd";
import Layout from '../../Layout'
import { useNavigate } from "react-router-dom";

const columns = [
    {
        title: "STT",
        dataIndex: "stt",
        width: 70,
    },
    {
        title: "Tên Dịch vụ/Sản phẩm",
        dataIndex: "name",
        render: (_: any, record: any) => (
            <div>
                <div className="font-semibold text-slate-800 dark:text-slate-100">
                    {record.name}
                </div>

                <div className="mt-1 text-[13px] text-slate-500 dark:text-slate-400">
                    {record.note}
                </div>
            </div>
        ),
    },
    {
        title: "SL",
        dataIndex: "qty",
        width: 90,
    },
    {
        title: "Đơn giá",
        dataIndex: "price",
        width: 160,
    },
    {
        title: "Thành tiền",
        dataIndex: "total",
        width: 180,
        render: (value: string) => (
            <div className="font-bold text-slate-800 dark:text-white">{value}</div>
        ),
    },
];

const dataSource = [
    {
        key: 1,
        stt: 1,
        name: "Gói chăm sóc da chuyên sâu",
        note: "Ghi chú dịch vụ...",
        qty: 1,
        price: "15.000.000",
        total: "15.000.000",
    },
];

const staffs = [
    {
        role: "NHÂN VIÊN TRỰC PAGE",
        name: "truc page admin",
        short: "PA",
        color:
            "bg-cyan-100 text-cyan-700 dark:bg-cyan-500/20 dark:text-cyan-300",
        border:
            "border-cyan-100 dark:border-cyan-500/20",
    },
    {
        role: "NHÂN VIÊN TELESALE",
        name: "tele admin",
        short: "TA",
        color:
            "bg-blue-100 text-blue-700 dark:bg-blue-500/20 dark:text-blue-300",
        border:
            "border-blue-100 dark:border-blue-500/20",
    },
    {
        role: "NHÂN VIÊN SALE CƠ SỞ",
        name: "co so admin",
        short: "SA",
        color:
            "bg-orange-100 text-orange-700 dark:bg-orange-500/20 dark:text-orange-300",
        border:
            "border-orange-100 dark:border-orange-500/20",
    },
];

export default function OrderDetailPage() {
    const navigate = useNavigate();
    return (
        <Layout>
            {/* HEADER */}
            <div className="mb-6 flex flex-wrap items-start justify-between gap-3">
                <div>
                    <div className="flex items-center gap-3">
                        <button
                            onClick={() => navigate("/list-order")}
                            className="
                                flex h-9 w-9 items-center justify-center rounded-xl
                                border border-slate-200 bg-white transition-all
                                hover:bg-slate-50
                                dark:border-slate-700 dark:bg-slate-800 dark:hover:bg-slate-700 text-000000e0
                            "
                        >
                            <ArrowLeftOutlined />
                        </button>

                        <div>
                            <div className="flex items-center gap-3">
                                <h1 className="text-[18px] font-bold text-slate-800 dark:text-white">
                                    Chi tiết đơn hàng DH-57131
                                </h1>

                                <Tag
                                    color="gold"
                                    className="flex items-center gap-2 rounded-full px-3 py-[2px] text-[13px]"
                                >
                                    <span className="h-2 w-2 rounded-full bg-yellow-500" />

                                    Ghi nợ
                                </Tag>
                            </div>

                            <div className="mt-1 text-[12px] text-slate-500 dark:text-slate-400">
                                Ngày tạo: 18:23:41 - 28/04/2026
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* CONTENT */}
            <div className="grid grid-cols-1 gap-5 xl:grid-cols-[1fr_370px] max-w-6xl mx-auto">
                {/* LEFT */}
                <div className="space-y-5">
                    {/* CUSTOMER */}
                    <Card
                        className="
                            overflow-hidden rounded-xl border-0 shadow-sm
                            dark:bg-slate-900
                        "
                        bodyStyle={{ padding: 0 }}
                    >
                        <div className="border-b border-slate-100 px-6 py-5 dark:border-slate-800">
                            <div className="flex items-center gap-3">
                                <UserOutlined className="text-[18px] text-cyan-600" />

                                <h2 className="text-[16px] font-bold text-slate-800 dark:text-white">
                                    Thông tin khách hàng
                                </h2>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 gap-6 px-6 py-6 lg:grid-cols-2">
                            {/* LEFT INFO */}
                            <div className="flex gap-4">
                                <div
                                    className="
                                        flex h-[48px] w-[48px] shrink-0 items-center justify-center
                                        rounded-full bg-cyan-100 text-[24px] font-bold
                                        text-cyan-700
                                        dark:bg-cyan-500/20 dark:text-cyan-300
                                    "
                                >
                                    KT
                                </div>

                                <div className="space-y-5">
                                    <div>
                                        <div className="mb-1 text-[12px] font-semibold uppercase tracking-wide text-slate-400">
                                            Tên khách hàng
                                        </div>

                                        <div className="text-[16px] font-semibold text-cyan-700 dark:text-cyan-400">
                                            Võ Mai Khánh Thu
                                        </div>
                                    </div>

                                    <div>
                                        <div className="mb-1 text-[12px] font-semibold uppercase tracking-wide text-slate-400">
                                            Địa chỉ
                                        </div>

                                        <div className="text-[14px] text-slate-700 dark:text-slate-300">
                                            Chưa cập nhật địa chỉ chi tiết
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* RIGHT INFO */}
                            <div className="space-y-5">
                                <div>
                                    <div className="mb-1 text-[12px] font-semibold uppercase tracking-wide text-slate-400">
                                        Số điện thoại
                                    </div>

                                    <div className="flex items-center gap-2 text-[14px] font-semibold text-slate-800 dark:text-white">
                                        <PhoneOutlined className="rotate-[230deg] text-slate-400" />
                                        0985999297
                                    </div>
                                </div>

                                <div>
                                    <div className="mb-1 text-[12px] font-semibold uppercase tracking-wide text-slate-400">
                                        Email
                                    </div>

                                    <div className="flex items-center gap-2 text-[14px] font-semibold text-slate-800 dark:text-white">
                                        <MailOutlined className="text-slate-400" />
                                        khanhthu.vo@gmail.com
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card>

                    {/* PRODUCT */}
                    <Card
                        className="overflow-hidden rounded-xl border-0 shadow-sm dark:bg-slate-900"
                        bodyStyle={{ padding: 0 }}
                    >
                        <div className="border-b border-slate-100 px-6 py-5 dark:border-slate-800">
                            <div className="flex items-center gap-3">
                                <InboxOutlined className="text-[18px] text-cyan-600" />

                                <h2 className="text-[16px] font-bold text-slate-800 dark:text-white">
                                    Dịch vụ & Sản phẩm
                                </h2>
                            </div>
                        </div>

                        <Table
                            columns={columns}
                            dataSource={dataSource}
                            pagination={false}
                            scroll={{ x: "max-content" }}
                            className="custom-ant-table"
                        />
                    </Card>

                    {/* STAFF */}
                    <Card
                        className="
                            overflow-hidden rounded-xl border border-cyan-100
                            bg-cyan-50/40 shadow-sm
                            dark:border-cyan-500/10 dark:bg-cyan-500/5
                        "
                        bodyStyle={{ padding: 24 }}
                    >
                        <div className="mb-6 flex items-center gap-3">
                            <UserOutlined className="text-[18px] text-cyan-600" />

                            <h2 className="text-[16px] font-bold text-slate-800 dark:text-white">
                                Nhân sự phụ trách
                            </h2>
                        </div>

                        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
                            {staffs.map((item, index) => (
                                <div
                                    key={index}
                                    className={`
                                        rounded-[12px] border bg-white p-5 shadow-sm
                                        dark:bg-slate-900
                                        ${item.border}
                                    `}
                                >
                                    <div className="mb-5 text-[10px] font-bold uppercase tracking-wide text-slate-400">
                                        {item.role}
                                    </div>

                                    <div className="flex items-center gap-4">
                                        <div
                                            className={`
                                                flex h-[40px] w-[40px] items-center justify-center
                                                rounded-full text-[14px] font-bold
                                                ${item.color}
                                            `}
                                        >
                                            {item.short}
                                        </div>

                                        <div className="text-[14px] font-semibold text-slate-800 dark:text-white">
                                            {item.name}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Card>
                </div>

                {/* RIGHT */}
                <div className="space-y-5">
                    {/* PAYMENT */}
                    <Card
                        className="rounded-xl border-0 shadow-sm dark:bg-slate-900"
                        bodyStyle={{ padding: 24 }}
                    >
                        <h2 className="mb-5 text-[16px] font-bold text-slate-800 dark:text-white">
                            Thanh toán
                        </h2>

                        <div className="space-y-4">
                            <div className="flex items-center justify-between text-[14px]">
                                <span className="text-slate-500 dark:text-slate-400">
                                    Tổng tiền hàng
                                </span>

                                <span className="font-semibold text-slate-800 dark:text-white">
                                    15.000.000
                                </span>
                            </div>

                            <div className="flex items-center justify-between text-[14px]">
                                <span className="text-slate-500 dark:text-slate-400">
                                    Giảm giá
                                </span>

                                <span className="font-semibold text-slate-800 dark:text-white">
                                    0
                                </span>
                            </div>

                            <div className="border-t border-dashed border-slate-200 pt-5 dark:border-slate-700">
                                <div className="flex items-center justify-between">
                                    <span className="text-[14px] font-bold text-slate-800 dark:text-white">
                                        Khách phải trả
                                    </span>

                                    <span className="text-[20px] font-bold text-cyan-600">
                                        15.000.000
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Card>

                    {/* EXTRA */}
                    <Card
                        className="rounded-xl border-0 shadow-sm dark:bg-slate-900"
                        bodyStyle={{ padding: 24 }}
                    >
                        <h2 className="mb-5 text-[16px] font-bold text-slate-800 dark:text-white">
                            Thông tin bổ sung
                        </h2>

                        <div className="space-y-6">
                            <div>
                                <div className="mb-2 text-[12px] font-bold uppercase tracking-wide text-slate-400">
                                    Chi nhánh tạo
                                </div>

                                <Tag
                                    color="purple"
                                    className="rounded-[4px] px-2 py-[4px] text-[12px]"
                                >
                                    Trần Hưng Đạo Q1
                                </Tag>
                            </div>

                            <div>
                                <div className="mb-2 text-[12px] font-bold uppercase tracking-wide text-slate-400">
                                    Ghi chú đơn hàng
                                </div>

                                <div
                                    className="
                                        rounded-[4px] bg-slate-100 px-4 py-2 text-[14px]
                                        italic text-slate-500
                                        dark:bg-slate-800 dark:text-slate-400
                                    "
                                >
                                    Không có ghi chú.
                                </div>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        </Layout>
    );
}